import Nope from 'nope-validator';

export const InviteCompanySchema = Nope.object().shape({
  companyId: Nope.string().required(),
  email: Nope.string().email().required(),
  companyName: Nope.string().required(),
});
